import React from 'react';

import { Trans } from '@lingui/macro';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';

import Select from '../Select';
import Button from '@mui/material/Button';
import NDISelector from '../../misc/NDISelector';
import NotifyContext from '../../contexts/Notify';

function init(settings) {
	const initSettings = {
		source: 'hls+memfs',
		...settings,
	};

	switch (initSettings.source) {
		case 'hls+diskfs':
		case 'rtmp':
		case 'srt':
		case 'whip-rtsp':
			break;
		default:
			initSettings.source = 'hls+memfs';
	}

	return initSettings;
}

export default function Control(props) {
	const settings = init(props.settings);
	const notify = React.useContext(NotifyContext);

	const [ndiOpen, setNdiOpen] = React.useState(false);

	const handleNdiProceed = (source) => {
		// attach selected NDI source into settings
		settings.source = 'ndi';
		settings.ndi = { name: source };
		props.onChange(settings, false);
		setNdiOpen(false);
	};

	// Set the defaults
	React.useEffect(() => {
		props.onChange(settings, true);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleChange = (what) => (event) => {
		const value = event.target.value;

		settings[what] = value;

		props.onChange(settings, false);
	};

	const items = [];

	items.push(
		<MenuItem key="hls+memfs" value="hls+memfs" disabled={!props.sources.includes('hls+memfs')}>
			HLS (memfs)
		</MenuItem>
	);

	items.push(
		<MenuItem key="hls+diskfs" value="hls+diskfs" disabled={!props.sources.includes('hls+diskfs')}>
			HLS (diskfs)
		</MenuItem>
	);

	items.push(
		<MenuItem key="rtmp" value="rtmp" disabled={!props.sources.includes('rtmp')}>
			RTMP
		</MenuItem>
	);

	items.push(
		<MenuItem key="srt" value="srt" disabled={!props.sources.includes('srt')}>
			SRT
		</MenuItem>
	);

	items.push(
		<MenuItem key="whip-rtsp" value="whip-rtsp" disabled={!props.sources.includes('whip-rtsp')}>
			<Trans>WHIP RTSP relay</Trans>
		</MenuItem>
	);

	items.push(
		<MenuItem key="ndi" value="ndi" disabled={!props.sources.includes('ndi')}>
			NDI
		</MenuItem>
	);

	return (
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<Select label={<Trans>Source</Trans>} value={settings.source} onChange={handleChange('source')}>
					{items}
				</Select>
				<Typography variant="caption">
					<Trans>Stream source for publication service (experimental).</Trans>
				</Typography>

				{settings.source === 'ndi' && (
					<div style={{ marginTop: '0.5em' }}>
						<Button variant="outlined" onClick={() => setNdiOpen(true)}>
							<Trans>Buscar dispositivos NDI</Trans>
						</Button>
						{props.restreamer && (
							<NDISelector open={ndiOpen} onClose={() => setNdiOpen(false)} onProceed={handleNdiProceed} restreamer={props.restreamer} i18n={props.i18n} notify={props.notify || notify} />
						)}
					</div>
				)}
			</Grid>
		</Grid>
	);
}

Control.defaulProps = {
	settings: {},
	sources: [],
	onChange: function (settings, automatic) {},
};
